/* Natural Glow — Filtro por categoría de la página de productos (ng-productos). */
(() => {
  const iniciar = (raiz = document) => {
    raiz.querySelectorAll('[data-ng-productos]').forEach((sec) => {
      if (sec.dataset.ngListo) return;
      sec.dataset.ngListo = 'true';
      const filtros = [...sec.querySelectorAll('[data-ng-filtro]')];
      const items = [...sec.querySelectorAll('[data-ng-cat]')];

      const aplicar = (cat) => {
        filtros.forEach((f) => f.setAttribute('aria-selected', String(f.dataset.ngFiltro === cat)));
        items.forEach((it) => {
          // Los paneles de "próximamente" (data-ng-solo) solo salen en su pestaña
          it.hidden = 'ngSolo' in it.dataset ? it.dataset.ngCat !== cat : cat !== 'todos' && it.dataset.ngCat !== cat;
        });
      };

      filtros.forEach((f) => {
        f.addEventListener('click', () => {
          aplicar(f.dataset.ngFiltro);
          f.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });
      });

      // Enlaces del panel de "próximamente": saltan a una pestaña con productos
      sec.querySelectorAll('[data-ng-ir]').forEach((b) => {
        b.addEventListener('click', () => filtros.find((f) => f.dataset.ngFiltro === b.dataset.ngIr)?.click());
      });

      // Flechas izquierda/derecha entre pestañas (patrón de accesibilidad de tabs)
      sec.querySelector('[role=tablist]')?.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const i = filtros.indexOf(document.activeElement);
        if (i < 0) return;
        const sig = filtros[(i + (e.key === 'ArrowRight' ? 1 : -1) + filtros.length) % filtros.length];
        sig.focus();
        sig.click();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => iniciar());
  else iniciar();
  document.addEventListener('shopify:section:load', (e) => iniciar(e.target));
})();
